import React from 'react'
import styled from 'styled-components'

import { CheckBox, CheckBoxOutlineBlank } from 'material-react-icons'

const StyledFormCheckbox = styled.div`
  align-items: center;
  margin-bottom: 12px;

  cursor: pointer;
`

const StyledLabelText = styled.div`
  flex: 1;
  margin-bottom: 0;
  color: #8b93a7;

  font-family: 'Open Sans', sans-serif;
  font-weight: 500;
  font-size: 13px;

  transition: all 0.5s;
  padding-left: 2px;
`

const StyledInput = styled.input`
  display: none;
`

const Label = styled.label`
  display: flex;
  align-items: center;

  cursor: pointer;
  margin: 0;
`

export default ({ input, label }) => {
  return (
    <StyledFormCheckbox>
      <Label htmlFor={input.name}>
        {input.value ? (
          <CheckBox color="#4C84FF" viewBox="3 0 24 24" />
        ) : (
          <CheckBoxOutlineBlank color="#ECECF0" viewBox="3 0 24 24" />
        )}
        <StyledLabelText htmlFor={input.name}>{label}</StyledLabelText>
      </Label>
      <StyledInput
        {...input}
        name={input.name}
        id={input.name}
        type="checkbox"
      />
    </StyledFormCheckbox>
  )
}
